import axiosInstance from "../axiosInstance";

const GET_TAGS = `/tags`;
const CREATE_TAG = `/tags`;

export const index = data => axiosInstance.get(GET_TAGS, data);

export const create = data => axiosInstance.post(CREATE_TAG, data);
